import { Route } from '@angular/router';
import { FormControl } from '@angular/forms';

export type ToFormControl<T> = { [P in keyof T]: FormControl<T[P]> };
// export type ToFormControl<T> = {
// 	[P in keyof T]: T[P] extends Array<any> ? FormArray<FormGroup<T[P]>> : FormControl<T[P]>
// };

export interface GlobalSettings<T> {
	Type: GlobalSettingType;
	Parameters: T;
}
export enum GlobalSettingType {
	Nomination = 'Nomination',
	Gas_Phone = 'Gas_Phone'
}

/** Roles are admin-managed and renamed freely, so prefer a grant; a role check names the role as stored. */
export interface ConfigItemRole {
	id: string;
	operator?: 'and' | 'or' | '';
}
export interface ConfigItemGrant {
	id: GRANTS;
	operator?: 'and' | 'or' | '';
}

// Grant keys come from VoltaServer's grant catalogue (src/app/core/access/grants.ts)
// via `npm run generate:access` there. Re-exported here so existing imports keep
// working; change the catalogue, not this file.
import type { GRANTS } from './access.generated';

export type { GRANTS };
export { GRANTS_LIST } from './access.generated';

export interface StatusItems {
	primary: string;
	success: string;
	warning: string;
	danger: string;
	info: string;
	basic: string;
}
export interface SizeItems {
	tiny: string;
	small: string;
	medium: string;
	large: string;
	giant: string;
}

export interface IdName {
	Id: number;
	Name: string;
}
export interface idName {
	id: number;
	Name: string;
}
export interface IdNameDesc {
	Id: number;
	Name: string;
	Description: string;
}
export interface NameDesc {
	Name: string;
	Description?: string;
}
